import { createContext } from 'react';

export const AngularContext = createContext();

export const AngularProvider = ({ $rootScope, $injector, $compile, children }) => {
    return (<AngularContext.Provider value={{ $rootScope, $injector, $compile }}>{children}</AngularContext.Provider>)
};